import dayjs from 'dayjs'

/** Seconds -> "H:MM:SS". */
export function formatDuration(totalSecs: number): string {
  const s = Math.max(0, Math.floor(totalSecs))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}

/** Seconds -> "Hh MMm" (compact, for totals). */
export function formatHours(totalSecs: number): string {
  const s = Math.max(0, Math.floor(totalSecs))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return `${h}h ${String(m).padStart(2, '0')}m`
}

/** Desetinné hodiny -> "38,1 h" (cíle a úvazky chodí z API rovnou v hodinách). */
export function formatDecimalHours(hours: number): string {
  return `${hours.toLocaleString('cs-CZ', { maximumFractionDigits: 1 })} h`
}

export function formatMoney(amount: number, currency: string): string {
  return `${amount.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
}

export function formatTime(iso: string): string {
  return dayjs(iso).format('HH:mm')
}

export function formatDate(iso: string): string {
  return dayjs(iso).format('D. M. YYYY')
}

const MONTHS = [
  'leden', 'únor', 'březen', 'duben', 'květen', 'červen',
  'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec',
]

/** "srpen 2026" — dayjs běží bez české lokalizace, název měsíce si dodáme sami. */
export function formatMonth(iso: string): string {
  const d = dayjs(iso)
  return `${MONTHS[d.month()]} ${d.year()}`
}
